const TRANSACTIONAL_PROFILE_EXTRA_DATA_KEYS = new Set([
  "NxtAtmcHsh",
  "PrvAtmcHsh",
  "DerivedPublicKey",
]);

export const coerceProfileExtraData = (
  extraData?: unknown | null,
): Record<string, string> => {
  if (!extraData || typeof extraData !== "object" || Array.isArray(extraData)) {
    return {};
  }

  return Object.fromEntries(
    Object.entries(extraData).filter(([, value]) => typeof value === "string"),
  );
};

export const sanitizeProfileExtraData = (
  extraData?: Record<string, string> | unknown | null,
) => {
  return Object.fromEntries(
    Object.entries(coerceProfileExtraData(extraData)).filter(
      ([key]) => !TRANSACTIONAL_PROFILE_EXTRA_DATA_KEYS.has(key),
    ),
  );
};

export const buildProfileImageExtraDataPatch = ({
  displayName,
  featuredImageURL,
  largeProfilePicURL,
}: {
  displayName?: string | null;
  featuredImageURL?: string | null;
  largeProfilePicURL?: string | null;
}) => {
  return {
    ...(displayName ? { DisplayName: displayName } : {}),
    ...(featuredImageURL ? { FeaturedImageURL: featuredImageURL } : {}),
    ...(largeProfilePicURL ? { LargeProfilePicURL: largeProfilePicURL } : {}),
  };
};
